module.exports = __webpack_public_path__ + "static/08-f5e2763a13fbd4faac07c5cc2b406021.jpg";